import { Susoft } from "@/types/general";
import { integrationsApi } from "./integrationsApi";

export const susoftApi = integrationsApi.injectEndpoints({
    endpoints: (builder) => ({
        importSusoftData: builder.mutation<void, Susoft.DTO.Import>({
            query: (data) => ({
                url: "data-transfer/integrations/susoft/import",
                method: "POST",
                data,
            }),
        }),

        exportDataToSusoft: builder.mutation<void, Susoft.DTO.Export>({
            query: (data) => ({
                url: "data-transfer/integrations/susoft/export",
                method: "POST",
                data,
            }),
        }),
    }),
});

export const {
    useImportSusoftDataMutation,
    useExportDataToSusoftMutation,
} = susoftApi;
